module.exports = __webpack_public_path__ + "static/media/Apple iPhone XS Max Gold.51a6ff00.png";